/**
 * @flow
 * @relayHash 8dbbe95c646c61e830c773f830f34f46
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CSVImportEntity = "CUSTOMER" | "ITEM" | "ORDER" | "VENDOR";
export type CSVImportSceneFieldsQueryVariables = {|
  entityType: CSVImportEntity
|};
export type CSVImportSceneFieldsQueryResponse = {|
  +csvFieldDefinitions: $ReadOnlyArray<{|
    +key: string,
    +label: string,
    +required: boolean,
  |}>
|};
export type CSVImportSceneFieldsQuery = {|
  variables: CSVImportSceneFieldsQueryVariables,
  response: CSVImportSceneFieldsQueryResponse,
|};
*/


/*
query CSVImportSceneFieldsQuery(
  $entityType: CSVImportEntity!
) {
  csvFieldDefinitions(entityType: $entityType) {
    key
    label
    required
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "entityType",
    "type": "CSVImportEntity!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "csvFieldDefinitions",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "entityType",
        "variableName": "entityType"
      }
    ],
    "concreteType": "CSVFieldDefinition",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "key",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "label",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "required",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CSVImportSceneFieldsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CSVImportSceneFieldsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "CSVImportSceneFieldsQuery",
    "id": null,
    "text": "query CSVImportSceneFieldsQuery(\n  $entityType: CSVImportEntity!\n) {\n  csvFieldDefinitions(entityType: $entityType) {\n    key\n    label\n    required\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '39ae9d96d57067c135344b7ebda8db3e';
module.exports = node;
